import { api } from './client'

export type AlertSeverity = 'Info' | 'Warning' | 'Critical'

export interface AlertItem {
  type: string
  severity: AlertSeverity
  title: string
  detail: string
  count: number | null
  amount: number | null
  currency: string | null
  linkPath: string
}

export interface DashboardSummary {
  stockValue: number
  newOrdersLast7Days: number
  productionOrdersInExecution: number
  totalActiveAlerts: number
  topAlerts: AlertItem[]
}

export const getDashboardSummary = (workPointId?: string) =>
  api.get<DashboardSummary>('/rapoarte/dashboard', { params: workPointId ? { workPointId } : undefined }).then((r) => r.data)
export const getAlerts = () => api.get<AlertItem[]>('/rapoarte/alerte').then((r) => r.data)

// ---------- FR-ADM-003a — filtru de raportare pe punct de lucru ----------

export interface RapoarteWorkPointRef { id: string; code: string; name: string }
export const listRapoarteWorkPoints = () => api.get<RapoarteWorkPointRef[]>('/rapoarte/puncte-lucru').then((r) => r.data)
